import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconArrow from 'components/svg/IconArrow';
import MenuFooter from '../MenuFooter';

const Ul = styled.ul``;

const Li = styled.li``;

const A = styled.a``;

/**
 * Renders submenu items from sidebar
 *
 * @param {array} submenu array of items.
 * @param {func} goBack used to pass the event to the parent, and run the reverse animation.
 */

const Dropdown = ({ submenu, goBack, onClickEvent }) => {
  const onRedirect = path => {
    window.location.href = path;
  };

  const onClickItem = item => {
    if (onClickEvent) {
      onClickEvent(item.label, () => onRedirect(item.path));
    } else {
      onRedirect(item.path);
    }
  };

  return (
    <>
      <Ul>
        <Li>
          <A href="#" className="backToMain" onClick={goBack}>
            {' '}
            <IconArrow /> Back to Main Menu
          </A>
        </Li>
        {submenu.length > 0 &&
          submenu.map((item, index) => (
            <Li key={index}>
              <A
                href={item.path ? item.path : '#'}
                onClick={() => onClickItem(item)}
              >
                {item.label}
              </A>
            </Li>
          ))}
        <MenuFooter />
      </Ul>
    </>
  );
};

Dropdown.propTypes = {
  submenu: PropTypes.array,
  goBack: PropTypes.func,
  onClickEvent: PropTypes.func,
};

export default Dropdown;
